import React, { useEffect, useState } from "react"
import {
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  Collapse,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledCollapse,
  Label,
  Input,
  Toast,
  ToastBody,
  ToastHeader,
} from "reactstrap"

import { Link, useNavigate } from "react-router-dom"

//Import Breadcrumb

import classnames from "classnames"
// import { getUserProfile } from "api"
import { useDispatch } from "react-redux"
import Spinners from "components/Common/Spinner"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import { reinvite, reinviteVendor } from "helpers/fakebackend_helper"
import Swal from "sweetalert2"
import DeleteModal from "components/Common/DeleteModal"
import { deleteVendors, getVendor, getVendors } from "store/actions"
import VendorDetail from "./components/vendorDetail"
import VendorDocuments from "./components/vendorDocuments"
// import VendorDetail from "./components/vendorDetail"
// import VendorDocuments from "./components/vendorDocuments"
import VendorContacts from "./components/vendorContacts"
import VendorContracts from "./components/vendorContracts"

const ViewVendor = () => {
  document.title = "Vendor View"
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [customActiveTab, setcustomActiveTab] = useState("1")
  const [modal_center, setmodal_center] = useState(false)
  const [modal_center2, setmodal_center2] = useState(false)
  const [toast2, setToast2] = useState(false)

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const tab = searchParams.get("tab") || "1";
    setcustomActiveTab(tab);
  }, [location.search]); // Trigger when URL search changes

  const toggleCustom = tab => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("tab", tab);
    navigate(`?${searchParams.toString()}`, { replace: true }); // Update URL
  };

  const [loading, setLoading] = useState(true)
  const [vendorId, setVendorId] = useState()

  const vendorDetail = state => state.vendors.vendor.data
  const vendorProfile = useSelector(vendorDetail) || []

  const fetchData = async () => {
    const url = new URL(window.location.href)
    const vendorId = url.pathname.split("/view-vendor/")[1]
    setVendorId(vendorId)

    try {
      dispatch(getVendor(vendorId))

      setLoading(false)
    } catch (error) {
      console.error(error)
    }
  }
  useEffect(() => {
    fetchData()
  }, [dispatch])

  const handleEmail = async () => {
    try {
      const loadingSwal = Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        showConfirmButton: false,
        onBeforeOpen: () => {
          Swal.showLoading()
        },
      })

      const response = await reinviteVendor(vendorId)

      // Close loading spinner
      loadingSwal.close()

      if (response && response.status === true) {
        Swal.fire({
          title: "Success",
          icon: "success",
          text: "Vendor Has Been Reinvited.",
        })
      } else {
        Swal.fire({
          title: "Failure",
          icon: "error",
          text: "There was a problem while reinviting the Vendor.",
        })
      }
    } catch (error) {
      console.error("Error:", error)
      Swal.fire({
        title: "Error",
        icon: "error",
        text:
          error.response.data.message ||
          "An error occurred while reinviting the Vendor.",
      })
    }
  }

  const [deleteModal, setDeleteModal] = useState(false)
  const [vendorDeleteId, setVendorDeleteId] = useState()

  const onClickDelete = vendor => {
    setVendorDeleteId(vendor)
    setDeleteModal(true)
  }

  const handleDeleteUser = () => {
    dispatch(deleteVendors(vendorId))
    setDeleteModal(false)
    navigate("/vendors")
    // dispatch(getVendors(vendorId))
  }
  const [permission, setPermission] = useState(
    JSON.parse(localStorage.getItem("permission"))
  )
  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid={true}>
          <CardTitle className="h4" style={{ fontSize: "20px" }}>
            <div className="d-flex gap-2 mb-3">
              <i
                className="mdi mdi-arrow-left font-size-20"
                style={{ color: "grey" }}
                onClick={() => {
                  navigate(-1)
                }}
              ></i>
              Vendor Profile
            </div>
          </CardTitle>
          <Row>
            <Col lg={12}>
              <Card>
                {vendorProfile ? (
                  <CardBody>
                    <Row>
                      <div className="d-flex gap-2 ">
                        <div className="mb-3  ">
                          <img
                            src={vendorProfile?.vendor_details?.image}
                            // src={userProfile ? userProfile.image : avatar2}
                            alt=""
                            style={{ height: "140px", width: "140px" }}
                            className="avatar-xl rounded-4 img-fluid "
                          />
                        </div>
                        <div className="mb-3  " style={{ marginLeft: "10px" }}>
                          <b>{vendorProfile?.vendor_details?.vendor_name}</b>
                          <h6 className="mb-4">
                            @{vendorProfile?.vendor_details?.login_username}
                          </h6>

                          <h6 className="text-primary mb-0">
                            {vendorProfile?.vendor_details?.mobile_no}
                          </h6>
                          <h6 className="text-primary mb-2">
                            {vendorProfile?.vendor_details?.email_address}
                          </h6>

                          <Row className="d-flex  ">
                            <Col className="mt-1">
                              {permission
                                .filter(
                                  item =>
                                    item.page === "/edit-vendor/:id" &&
                                    item.access === 1
                                )
                                .map((item, index) => (
                                  <Link
                                    key={index}
                                    to={`/vendors/edit-vendor/${vendorId}`}
                                  >
                                    <button
                                      className="btn btn-soft-light btn-md"
                                      style={{
                                        color: "black",
                                        backgroundColor: "#F6F6F6",
                                      }}
                                    >
                                      <i
                                        className="mdi mdi-pencil"
                                        style={{
                                          color: "#3366cc",
                                          marginRight: "10px",
                                        }}
                                      ></i>{" "}
                                      Edit Profile
                                    </button>
                                  </Link>
                                ))}
                              {permission
                                .filter(
                                  item =>
                                    item.page === "delete-vendor" &&
                                    item.access === 1
                                )
                                .map((item, index) => (
                                  <button
                                    key={index}
                                    className="btn btn-soft-light btn-md"
                                    onClick={onClickDelete}
                                    style={{
                                      marginLeft: "10px",
                                      color: "black",
                                      fontweight: "bold",
                                      backgroundColor: "#F6F6F6",
                                    }}
                                  >
                                    <i
                                      className="mdi mdi-delete"
                                      style={{
                                        color: "#3366cc",
                                        marginRight: "10px",
                                      }}
                                    ></i>
                                    Delete Vendor
                                  </button>
                                ))}
                              {permission
                                .filter(
                                  item =>
                                    item.page === "reinvite-vendor" &&
                                    item.access === 1
                                )
                                .map((item, index) => (
                                  <button
                                    key={index}
                                    className="btn btn-soft-light btn-md"
                                    onClick={handleEmail}
                                    style={{
                                      marginLeft: "10px",
                                      color: "black",
                                      fontweight: "bold",
                                      backgroundColor: "#F6F6F6",
                                    }}
                                  >
                                    <i
                                      className="bx bx-mail-send"
                                      style={{
                                        color: "#3366cc",
                                        marginRight: "10px",
                                      }}
                                    ></i>
                                    Resend Invitation
                                  </button>
                                ))}

                              <div
                                className="position-fixed top-0 end-0 p-3"
                                style={{ zIndex: "1005" }}
                              ></div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </Row>

                    <Nav tabs className="nav-tabs-custom ">
                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({
                            active: customActiveTab === "1",
                          })}
                          onClick={() => {
                            toggleCustom("1")
                          }}
                        >
                          <span className="d-block d-sm-none">
                            <i className="fas fa-home"></i>
                          </span>
                          <span className="d-none d-sm-block">
                            Vendor Details
                          </span>
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        {permission
                          .filter(
                            item =>
                              item.page === "view-vendor-document-list" &&
                              item.access === 1
                          )
                          .map((item, index) => (
                            <NavLink
                              key={index}
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: customActiveTab === "2",
                              })}
                              onClick={() => {
                                toggleCustom("2")
                              }}
                            >
                              <span className="d-block d-sm-none">
                                <i className="far fa-user"></i>
                              </span>
                              <span className="d-none d-sm-block">
                                Documents
                              </span>
                            </NavLink>
                          ))}
                      </NavItem>
                      <NavItem>
                        {permission
                          .filter(
                            item =>
                              item.page === "vendor-contacts" &&
                              item.access === 1
                          )
                          .map((item, index) => (
                            <NavLink
                              key={index}
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: customActiveTab === "3",
                              })}
                              onClick={() => {
                                toggleCustom("3")
                              }}
                            >
                              <span className="d-block d-sm-none">
                                <i className="far fa-envelope"></i>
                              </span>
                              <span className="d-none d-sm-block">
                                Vendor Contacts
                              </span>
                            </NavLink>
                          ))}
                      </NavItem>
                      <NavItem>
                            <NavLink
                             key="4 "
                             style={{ cursor: "pointer" }}
                             className={classnames({
                               active: customActiveTab === "4",
                             })}
                             onClick={() => {
                               toggleCustom("4")
                             }}
                            >
                              <span className="d-block d-sm-none">
                                <i className="far fa-envelope"></i>
                              </span>
                              <span className="d-none d-sm-block">
                                Vendor Contracts
                              </span>
                            </NavLink>
                      </NavItem>
                    </Nav>

                    <TabContent
                      activeTab={customActiveTab}
                      className="p-3 text-muted"
                    >
                      <TabPane tabId="1">
                        <Row>
                          <Col sm="12">
                            <VendorDetail vendorProfile={vendorProfile} />
                          </Col>
                        </Row>
                      </TabPane>
                      <TabPane tabId="2">
                        <Row>
                          <Col sm="12">
                            <VendorDocuments />
                          </Col>
                        </Row>
                      </TabPane>
                      <TabPane tabId="3">
                        <Row>
                          <Col sm="12">
                            <VendorContacts />
                          </Col>
                        </Row>
                      </TabPane>
                      <TabPane tabId="4">
                        <Row>
                          <Col sm="12">
                            <VendorContracts />
                          </Col>
                        </Row>
                      </TabPane>
                    </TabContent>
                  </CardBody>
                ) : (
                  <Spinners setLoading={setLoading} />
                )}
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ViewVendor
